import Icon from './Icon';
import Link from './Link';

type DesktopNavigationProps = {
  // Define props if needed
  items?: Array<{
    label: string;
    href: string;
    icon?: string;
    className?: string;
    target?: string;
    rel?: string;
  }>;
};

// transition - all duration - 300 ease -in -out

const DesktopNavigation = ({ items = [] }: DesktopNavigationProps) => {
  return (
    <nav className="desktop-navigation hidden md:block">
      <ul className="flex flex-row items-center gap-5">
        {items.map((item, index) => (
          <li key={index}>
            <Link
              href={item.href}
              target={item.target}
              rel={item.rel}
              className={`
                                cursor-pointer px-6 py-2 rounded-md
                                hover:bg-secondary-300 hover:animate-fade-in duration-300
                                flex flex-row items-center gap-2  ${item.className || ''}
                            `}
            >
              {item.icon && <Icon name={item.icon} />}
              {item.label}
            </Link>
          </li>
        ))}
      </ul>
    </nav>
  );
};

export default DesktopNavigation;
